import { TASK_DATA } from '../../../../../../constants/tasks';

const useMutateTasksListTask = () => {
  const addTask = (fieldArrayHelpers) => {
    fieldArrayHelpers.push(TASK_DATA);
  };

  const removeTask = (fieldArrayHelpers, index) => {
    fieldArrayHelpers.remove(index);
  };

  return { addTask, removeTask };
};

export default useMutateTasksListTask;
